'use strict';

angular.module('theme').directive('rememberValue', function ($cookies, md5) {
	return {
		restrict: 'A',
		scope: {
			cookieName: '@rememberValue'
		},
		link: function (scope, $element) {
			var cookieValue = $cookies.get(scope.cookieName);
			if (cookieValue) {
				$element.val(cookieValue);
			}

			$element.on('blur', function () {
				//Needs to be lowercase because backend is always lowercase
				localStorage.setItem('mkref', md5.createHash(($element.val().toLowerCase())));
			});
		}
	};
});
